export const DONE_TASK = 'DONE_TASK';  // 已完成的任务
export const UNDONE_TASK = 'UNDONE_TASK';  // 未完成的任务
export const OVERDUE_TASK = 'OVERDUE_TASK';  // 已逾期的任务
export const STORE_TRAININGCLASS_DETAIL = 'STORE_TRAININGCLASS_DETAIL';  // 暂存的培训班
export const TASK_TAB_CHANGE = 'TASK_TAB_CHANGE';  // 我的任务tab change
export const COLLECT_TAB_CHANGE = 'COLLECT_TAB_CHANGE';  // 我的收藏teb cahnge
